import React from "react";
import PropTypes from "prop-types";
// MUI
import { Box, Button, IconButton, MenuItem, TableCell } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
// Local
import i18n from "../../i18n";

export default function EditorSelectCell({
    field,
    row,
    handleSave,
    handleChange,
    currentValues,
    styles = {},
}) {
    const [selectVisible, setSelectVisible] = React.useState(false);
    const [originalValue, setOriginalValue] = React.useState(null);
    const { id } = row;
    const permissionsVariables = field.items || [];

    // Null and undefined check
    if (!currentValues || !currentValues[id] || !field || !row) {
        return null;
    }

    const value = currentValues[id][field.id];

    const handleClick = (event) => {
        setOriginalValue(value);
        setSelectVisible(!selectVisible);
    };

    const handleCancel = async () => {
        await handleChange({ target: { value: originalValue } }, row, field.id);
        if (value !== originalValue) {
            handleSave(row.id, row.role, row.controller);
        }
        setSelectVisible(false);
    };

    const handleSend = async () => {
        await handleSave(row.id, row.role, row.controller);
        setSelectVisible(false);
    };

    const baseStyle = styles || {};

    return (
        <TableCell key={field.id} align="left" sx={{ ...baseStyle }}>
            {selectVisible ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <InputLabel>{i18n.t("text.choose_permissions")}</InputLabel>
                        <Select
                            labelId={field.label}
                            id={field.id}
                            value={value || ""}
                            label="Choose permission"
                            onChange={(event) => handleChange(event, row.id, field.id)}
                        >
                            {permissionsVariables.map((permission) => (
                                <MenuItem
                                    key={`${permission}_${field.id}`}
                                    value={permission}
                                >
                                    {i18n.t(`permissions.${permission}`)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            alignSelf: "stretch",
                        }}
                    >
                        <IconButton onClick={handleSend}>
                            <CheckIcon />
                        </IconButton>
                        <IconButton onClick={handleCancel}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            ) : (
                <Button color="inherit" onClick={(event) => handleClick(event)}>
                    {i18n.t(`permissions.${value}`)}
                </Button>
            )}
        </TableCell>
    );
}

// Add PropTypes validation
EditorSelectCell.propTypes = {
    field: PropTypes.object.isRequired,
    row: PropTypes.shape({
        id: PropTypes.number.isRequired,
        role: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
        }),
        controller: PropTypes.string,
    }).isRequired,
    handleSave: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    currentValues: PropTypes.object.isRequired,
};
